import console from './logger/console'
import elasticConsole from './logger/elastic-console'
import api from './api'

const env = process.env.REACT_APP_NODE_ENV

const services = {
  //  INI ADALAH PENDAFTARA MODULE YANG NANTINYA BISA DI EXPOSE KE LUAR ( MIDDLEWARE , DLL)
  log: env === 'development' ? console : elasticConsole,
  getLocal: env === 'development' ? console : elasticConsole,
  writeLocal: env === 'development' ? console : elasticConsole,
  api
}

export default services
